import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@/store/app/storeTypes";
import type { SearchFilters } from "@/features/sparxsEditor/lib/advancedSearch/types/searchTypes";

export type CatalogStaleChip = { key: string; value: string };

export type CatalogSearchState = {
  filters: SearchFilters;
  staleChips: CatalogStaleChip[];
};

const initialState: CatalogSearchState = {
  filters: {},
  staleChips: [],
};

const catalogSearchSlice = createSlice({
  name: "catalogSearch",
  initialState,
  reducers: {
    catalogSearchFiltersSet: (state, action: PayloadAction<SearchFilters>) => {
      state.filters = action.payload;
    },
    catalogSearchReplace: (
      _state,
      action: PayloadAction<CatalogSearchState>,
    ): CatalogSearchState => action.payload,
    catalogSearchStaleChipsSet: (
      state,
      action: PayloadAction<CatalogStaleChip[]>,
    ) => {
      state.staleChips = action.payload;
    },
    catalogSearchReset: () => initialState,
  },
});

export const {
  catalogSearchFiltersSet,
  catalogSearchReplace,
  catalogSearchStaleChipsSet,
  catalogSearchReset,
} = catalogSearchSlice.actions;

export default catalogSearchSlice.reducer;

export const selectCatalogSearchState = (
  state: RootState,
): CatalogSearchState => state.editor.catalogSearch;

export const selectCatalogSearchFilters = (state: RootState): SearchFilters =>
  state.editor.catalogSearch.filters;

export const selectCatalogStaleChips = (state: RootState): CatalogStaleChip[] =>
  state.editor.catalogSearch.staleChips;
